import React from "react";
import InnerPageLayout from "../components/Layout/InnerPageLayout";
import BreadCrumb from "../components/Breadcrumb/BreadCrumb";
import FaqMainOne from "../components/FaqCom/FaqMainOne";
import { useParams } from "react-router-dom";

import WorkProcessOne from "../components/WorkProcess/WorkProcessOne";
import CardFeatures from "../components/Features/CardFeatures";
import industriesData from "../data/industriesData";

export function AboutService({ industry }) {
  if (!industry) {
    return null;
  }

  return (
    <section className="pt-16 mb-16 md:pt-[153px] md:pb-[153px]">
      <div className="theme-container w-full mx-auto px-4">
        <div className="w-full">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
            {/* Content Section */}
            <div className={`flex flex-col justify-center lg:col-span-5 ${industry.imagePosition === "left" ? "lg:order-2" : "lg:order-1"}`}>
              <h2 className="text-34 sm:text-34 md:text-48 font-semibold text-white mb-8 sm:mb-[50px]  w-full xl:w-full">
                {industry.title}
              </h2>
              <p className="mb-6 sm:mb-8 md:mb-10 text-paragraph text-base sm:text-lg leading-relaxed">
                {industry.detailedDescription || industry.description}
              </p>
            </div>

            {/* Image Section */}
            <div className={`relative flex flex-col justify-center w-full lg:col-span-7 ${industry.imagePosition === "left" ? "lg:order-1" : "lg:order-2"}`}>
              <div className="relative overflow-hidden rounded-xl shadow-2xl">
                <img
                  src={industry.image}
                  alt={industry.title}
                  className="w-full h-auto object-cover transition-transform duration-300 hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default function IndustryDetails() {
  const { slug } = useParams();
  const industry = industriesData.find((item) => item.slug === slug);

  return (
    <InnerPageLayout>
      <BreadCrumb 
        pageTitle={industry.title}
        items={[
          { label: "Industries", path: "/industries" },
          { label: industry.title, path: `/industry/${slug}` }
        ]}
      />
      {industry ? (
        <>
          <AboutService industry={industry} />
          <WorkProcessOne
            pillName={industry.workProcess?.pillName}
            heading={industry.workProcess?.heading}
            processSteps={industry.workProcess?.processSteps}
            imageSrc={industry.workProcess?.imageSrc}
            parallaxElements={industry.workProcess?.parallaxElements}
          />
          <CardFeatures
            headerContent={industry.features?.headerContent}
            cards={industry.features?.cards}
            backgroundImages={industry.features?.backgroundImages}
          />
          <FaqMainOne
            faqs={industry.faqs || []}
            pillName="Key Solutions"
            heading="Custom Digital Solutions Designed for Industry Excellence"
          />
        </>
      ) : (
        <section className="theme-container w-full mx-auto px-4 py-20">
          <div className="text-center text-white">
            <h2 className="text-3xl font-semibold mb-4">Industry Not Found</h2>
            <p className="text-paragraph text-base">
              We couldn&rsquo;t find the industry you were looking for. Please check the URL or return to the industries page.
            </p>
          </div>
        </section>
      )}
    </InnerPageLayout>
  );
}
